import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Drug from "../views/Drug.vue";
import HealthyLife from "../views/HealthyLife.vue";
import UdsHome from "../views/UdsHome.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: '药联健康APP下载'
    }
  },
  {
    path: "/drug",
    name: "Drug",
    component: Drug,
    meta: {
      title: '药联健康APP下载'
    }
  },
  {
    path: "/healthylife",
    name: "HealthyLife",
    component: HealthyLife,
    meta: {
      title: '药联健康APP下载'
    }
  },
  {
    path: "/download/home",
    name: "Home",
    component: Home,
    meta: {
      title: '药联健康APP下载'
    }
  },
  {
    path: "/download/drug",
    name: "Drug",
    component: Drug,
    meta: {
      title: '药联健康APP下载'
    }
  },
  {
    path: "/download/healthylife",
    name: "HealthyLife",
    component: HealthyLife,
    meta: {
      title: '药联健康APP下载'
    }
  },
  {
    path: "/udshome",
    name: "UdsHome",
    component: UdsHome,
    meta: {
      title: '健康宝APP下载'
    }
  },
  {
    path: "/download/udshome",
    name: "UdsHome",
    component: UdsHome,
    meta: {
      title: '健康宝APP下载'
    }
  }

  
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
